"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRefreshTokenMutation = exports.useResendVerifyUserMutation = exports.useResetUserPasswordMutation = exports.useForgetPasswordMutation = exports.useVerifyUserMutation = exports.useLoginUserMutation = exports.useRegisterUserMutation = exports.AuthApi = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
const http_1 = require("../../http");
exports.AuthApi = (0, react_1.createApi)({
    reducerPath: "auth",
    tagTypes: ["auth"],
    baseQuery: (0, react_1.fetchBaseQuery)({
        baseUrl: `${http_1.ApiBaseUrl}`,
    }),
    endpoints: (build) => ({
        // register user mutation
        registerUser: build.mutation({
            query: (data) => ({
                url: "auth/register/",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["auth"],
            transformResponse: ({ data }) => data,
        }),
        // login user mutation
        loginUser: build.mutation({
            query: (data) => ({
                url: "login/",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["auth"],
        }),
        // refresh token mutation
        refreshToken: build.mutation({
            query: ({ token }) => ({
                url: "refresh/",
                method: "POST",
                body: { token },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }),
            invalidatesTags: ["auth"],
        }),
        // verify user mutation
        verifyUser: build.mutation({
            query: ({ id, data }) => ({
                url: `verification-code/${id}/`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["auth"],
        }),
        // resend verification code mutation
        resendVerifyUser: build.mutation({
            query: (email) => ({
                url: `user-send-verify-code/${email}/`,
                method: "POST",
                body: {},
            }),
            invalidatesTags: ["auth"],
        }),
        // request to reset user password mutation
        forgetPassword: build.mutation({
            query: (data) => ({
                url: `reset-password-request/`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["auth"],
        }),
        //reset user password mutation
        resetUserPassword: build.mutation({
            query: (data) => ({
                url: `reset-password/`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["auth"],
        }),
    }),
});
exports.useRegisterUserMutation = exports.AuthApi.useRegisterUserMutation, exports.useLoginUserMutation = exports.AuthApi.useLoginUserMutation, exports.useVerifyUserMutation = exports.AuthApi.useVerifyUserMutation, exports.useForgetPasswordMutation = exports.AuthApi.useForgetPasswordMutation, exports.useResetUserPasswordMutation = exports.AuthApi.useResetUserPasswordMutation, exports.useResendVerifyUserMutation = exports.AuthApi.useResendVerifyUserMutation, exports.useRefreshTokenMutation = exports.AuthApi.useRefreshTokenMutation;
